import { Injectable, Injector } from '@angular/core';
import { vectorTaggingToolsConfig } from '../../../../cross-team-shared/tools.config';
import { AbstractShapeTool2D } from '../shared/abstract-shape-tool-2d';
import { CrosshairService } from '../shared/crosshair.service';
import {
  IncrementalShapeTool,
  IncrementalShapeToolHelper,
} from '../shared/tool-helpers/incremental-shape-tool-helper';
import { ClickxToolHelper, getClickxOptions } from './clickx-tool-helper';
import { PolygonSecondaryToolbarComponent } from './polygon-secondary-toolbar.component';

type PolygonMode = 'manual' | 'clickx';

@Injectable()
export class PolygonTool
  extends AbstractShapeTool2D
  implements IncrementalShapeTool
{
  readonly name = vectorTaggingToolsConfig.Polygon.name;
  private _mode: PolygonMode = 'manual';

  constructor(
    private crosshairService: CrosshairService,
    injector: Injector,
  ) {
    super(injector);
  }

  get mode() {
    return this._mode;
  }

  set mode(value: PolygonMode) {
    this._mode = value;
    this.updateCrosshairVisibility();
  }

  override async onActivate() {
    if (getClickxOptions(this.store.state().output)) {
      this.secondaryToolbarType = PolygonSecondaryToolbarComponent;
    }

    await super.onActivate();

    this.updateCrosshairVisibility();
    this.onEvent('container', 'mousedown', this.startShape);
  }

  override onDeactivate() {
    super.onDeactivate();
    this.crosshairService.hideCrosshair();
  }

  private updateCrosshairVisibility() {
    if (this._mode === 'manual') {
      this.crosshairService.hideCrosshair();
    } else {
      this.crosshairService.showCrosshair();
    }
  }

  private startShape() {
    if (this.mode === 'clickx') {
      this.registerHelper(
        new ClickxToolHelper(this, this.store('vectorOverlay'), this.injector),
      );
    } else {
      this.registerHelper(
        new IncrementalShapeToolHelper(
          this,
          this.store('vectorOverlay'),
          this.injector,
        ),
      );
    }
  }
}
